import PropTypes from 'prop-types';
// material
import { Box } from '@mui/material';
import { SETTINGS } from 'src/config/settings';
import { Link } from 'react-router-dom';

// ----------------------------------------------------------------------

Logo.propTypes = {
    sx: PropTypes.object,
};

export default function Logo({ sx, path = SETTINGS.LogoImage }) {
    return (
        <Box margin="auto" component="img" src={path} sx={{ width: 180, height: 'auto', ...sx }} />
    );
}
